import React from 'react';

import { SectionCard } from '~components';
import Icon, { faInfoCircle } from '~components/icon';
import { Pie } from '~components/visualisation';

import ChartLegend from './ChartLegend';

export interface FormattedDataItem {
  id: string;
  label: string;
  value: number;
  color: string;
}

interface ChartDataItem {
  title: string;
  value: number;
  color: string;
}

interface ComponentProps {
  data: ChartDataItem[];
}

const Overview: React.FC<ComponentProps> = ({ data }) => {
  const formattedData: FormattedDataItem[] = data.map(({ title, value, color }) => ({
    id: title,
    label: title,
    value,
    color,
  }));

  return (
    <SectionCard
      title="Budget Overview"
      description="Overall budget allocation and utilisation"
      className="budget-overview"
    >
      {data.length > 0 ? (
        <>
          <div className="overview-layout">
            <div className="overview-chart-container">
              <div className="overview-pie-chart">
                <Pie
                  data={formattedData}
                  className="overview-pie"
                  responsive
                  arcLabelFormat="percentage"
                  tooltipFormat="dollars"
                />
              </div>
            </div>

            <div className="overview-legend-container">
              <ChartLegend data={data} />
            </div>
          </div>
        </>
      ) : (
        <div className="no-data-message">
          <Icon icon={faInfoCircle} />
          No categories included in the budget.
        </div>
      )}
    </SectionCard>
  );
};

export default Overview;
